<div class="content-wrapper">
  <div class="placeholder">
    <div class="animated-background"></div>
  </div>
</div>
